export default {
  data() {
    return {
      hasCompanySelectionError: false,
    };
  },
  methods: {
    emitSave(...args) {
      if (this.validateCompanySelection()) {
        this.$emit('on-save', ...args);
      }
    },
    validateCompanySelection() {
      if (!this.availableToAllCompanies && !this.form.company_ids?.length) {
        this.setCompanySelectionError();
        return false;
      }

      this.clearCompanySelectionError();
      return true;
    },
    setCompanySelectionError() {
      this.hasCompanySelectionError = true;
      this.form.errors = {
        ...this.form.errors,
        company_ids: this.companyRequiredMessage,
      };
    },
    clearCompanySelectionError() {
      if (this.hasCompanySelectionError) {
        delete this.form.errors.company_ids;
        this.hasCompanySelectionError = false;
      }
    },
  },
};
